import type { AnalysisProgress } from '@tailorcast/shared-types';

interface AnalysisProgressBarProps {
  data: AnalysisProgress | undefined;
  isLoading: boolean;
}

export function AnalysisProgressBar({ data, isLoading }: AnalysisProgressBarProps) {
  if (isLoading || !data) return null;
  if (data.status === 'completed') {
    return (
      <div className="text-sm text-green-600">
        Analysis complete: {data.analyzedProducts} products analyzed
        {data.failedProducts > 0 && ` (${data.failedProducts} failed)`}
      </div>
    );
  }
  if (data.status === 'failed') {
    return <div className="text-sm text-red-600">Analysis failed</div>;
  }
  if (data.status !== 'running' && data.status !== 'pending') return null;

  const percent = data.totalProducts > 0 ? (data.analyzedProducts / data.totalProducts) * 100 : 0;

  return (
    <div>
      <div className="flex justify-between text-sm text-gray-600 mb-1">
        <span>Analyzing products...</span>
        <span>
          {data.analyzedProducts}/{data.totalProducts}
        </span>
      </div>
      <div className="w-full bg-gray-200 rounded-full h-2">
        <div
          className="bg-tailorcast-secondary h-2 rounded-full transition-all"
          style={{ width: `${percent}%` }}
        />
      </div>
    </div>
  );
}
